class CustomUrls {
    ApiUrl() {
        // return 'http://20.36.170.122:8000/'
        return 'https://reportes.chedraui.com.mx:8000/'
    }
}

export default new CustomUrls()